import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import axios from "axios";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const editorS3FileManagerServices = {
  //Folder
  getS3EditorFolders,
  createS3EditorFolder,
  moveS3EditorFolder,
  copyS3EditorFolder,
  updateS3EditorFolder,
  duplicateS3EditorFolder,
  deleteS3EditorFolderFile,
  softDeleteS3EditorFolder,

  //File
  uploadFilesToS3,
  moveS3EditorFile,
  createS3ZipController,
  extractS3ZipController,
  readS3DatasetFile,
  readS3DatasetFileURL,
  uploadMultipleLocalS3EditorFolder
};

// Upload MultiFile
async function uploadFilesToS3(formData) {
  const response = await axios.post(
    `${config.API_URL_USER_ONBOARDING}uploadFilesToS3`,
    formData
  );
  const data = response?.data;
  handleResponse(data);
  return data;
}

async function uploadMultipleLocalS3EditorFolder(formData) {
  const response = await axios.post(
    `${config.API_URL_USER_ONBOARDING}uploadMultipleLocalS3EditorFolder`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  const data = response?.data;
  handleResponse(data);
  return data;
};

async function readS3DatasetFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}readS3DatasetFile`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  return data;
}

async function readS3DatasetFileURL(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}readS3DatasetFileURL`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  return data;
}

async function moveS3EditorFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}moveS3EditorFile`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function createS3ZipController(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createS3ZipController`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function extractS3ZipController(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}extractS3ZipController`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getS3EditorFolders(studyId, type, searchData, path, dataType) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getS3EditorFolders/${studyId}/${type}?search=${searchData || ""}&path=${path || ""}&dataType=${dataType || ""}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function createS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createS3EditorFolder`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function softDeleteS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteS3EditorFolder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function moveS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}moveS3EditorFolder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function copyS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}copyS3EditorFolder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateS3EditorFolder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function duplicateS3EditorFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateS3EditorFolder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function deleteS3EditorFolderFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteS3EditorFolderFile`,
    headersWithAuth("DELETE", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}